





















import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class StatusDisplayer extends Mixins<BaseComponent>(BaseComponent) {

  @Prop(String)
  private status!: string;

  @Prop({type: String, default: null})
  private details!: string | null;

  @Prop({type: Boolean, default: false})
  private detailsLoading!: boolean;

  @Prop(String)
  private color!: string;

  @Prop({type: String, default: null})
  private tooltip!: string | null;
}
